"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var store_1 = require("owa-theme/lib/store/store");
var React = require("react");
var styles = require('./Theme.scss');
var classNames = require('classnames/bind').bind(styles);
var spriteStyles = require('owa-sprite/dist/styles/theme_sprite.css');
var ThemeSwatch = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeSwatch, _super);
    function ThemeSwatch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (ev) {
            ev.stopPropagation();
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.themeId);
            }
        };
        return _this;
    }
    ThemeSwatch.prototype.render = function () {
        var themeId = this.props.themeId;
        var isChecked = themeId === store_1.store.theme;
        return (React.createElement("div", { className: classNames(styles.swatch, {
                selected: isChecked,
            }), onClick: this.onClick, "data-is-focusable": "true", role: "option", "aria-checked": isChecked, "aria-label": owa_options_strings_1.default["themeDisplayName_" + themeId], title: owa_options_strings_1.default["themeDisplayName_" + themeId] },
            React.createElement("i", { className: classNames(spriteStyles["theme-icon-" + themeId], styles.image) })));
    };
    ThemeSwatch = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThemeSwatch);
    return ThemeSwatch;
}(React.Component));
exports.default = ThemeSwatch;
//# sourceMappingURL=ThemeSwatch.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/view/ThemeSwatch.js
// module id = 3730
// module chunks = 2